export const users = [
  {
    id: 1,
    firstName: 'John',
    lastName: 'Doe',
    role: 'application-admin',
    email: 'john_doe@cliniciannexus.com',
    org_id: 1,
  },
  {
    id: 2,
    firstName: 'Jane',
    lastName: 'Smith',
    role: 'PHY-client-user',
    email: 'jane_smith@orgone.com',
    org_id: 889900,
  },
  {
    id: 3,
    firstName: 'Bob',
    lastName: 'Johnson',
    role: 'PHY-client-user',
    email: 'bob_johnson@orgone.com',
    org_id: 889900,
  },
  {
    id: 4,
    firstName: 'Alice',
    lastName: 'Williams',
    role: 'APP-client-user',
    email: 'alice_williams@orgone.com',
    org_id: 889900,
  },
  {
    id: 5,
    firstName: 'Eve',
    lastName: 'Brown',
    role: 'consultant-admin',
    email: 'eve_brown@sullivancotter.com',
    org_id: 1,
  },
  {
    id: 6,
    firstName: 'Charlie',
    lastName: 'Davis',
    role: 'PHY-client-user',
    email: 'charlie_davis@companytwo.com',
    org_id: 254,
  },
  {
    id: 7,
    firstName: 'David',
    lastName: 'Garcia',
    role: 'APP-client-user',
    email: 'david_garcia@companytwo.com',
    org_id: 254,
  },
  {
    id: 8,
    firstName: 'John ',
    lastName: 'Williams',
    role: 'APP-client-user',
    email: 'john_w@companytwo.com',
    org_id: 254,
  },
  {
    id: 9,
    firstName: 'John ',
    lastName: 'Smith',
    role: 'APP-client-user',
    email: 'john_s@companytwo.com',
    org_id: 254,
  },
  {
    id: 10,
    firstName: 'John ',
    lastName: 'Cohan',
    role: 'APP-client-user',
    email: 'john_c@companytwo.com',
    org_id: 254,
  },
  {
    id: 11,
    firstName: 'John ',
    lastName: 'Lennon',
    role: 'APP-client-user',
    email: 'john_l@companytwo.com',
    org_id: 254,
  },
  {
    id: 12,
    firstName: 'John ',
    lastName: 'Mccartney',
    role: 'APP-client-user',
    email: 'john_m@companytwo.com',
    org_id: 254,
  },
  {
    id: 13,
    firstName: 'John ',
    lastName: 'Harrison',
    role: 'APP-client-user',
    email: 'john_h@companytwo.com',
    org_id: 254,
  },
  {
    id: 14,
    firstName: 'John ',
    lastName: 'Star',
    role: 'APP-client-user',
    email: 'john_s@companytwo.com',
    org_id: 254,
  },
  {
    id: 15,
    firstName: 'John ',
    lastName: 'Richards',
    role: 'APP-client-user',
    email: 'john_r@companytwo.com',
    org_id: 254,
  },
  {
    id: 16,
    firstName: 'John ',
    lastName: 'Jagger',
    role: 'APP-client-user',
    email: 'john_j@companytwo.com',
    org_id: 254,
  },
  {
    id: 17,
    firstName: 'John ',
    lastName: 'Watts',
    role: 'APP-client-user',
    email: 'john_w@companytwo.com',
    org_id: 254,
  },
  {
    id: 18,
    firstName: 'John ',
    lastName: 'Wood',
    role: 'APP-client-user',
    email: 'john_w@companytwo.com',
    org_id: 254,
  },
  {
    id: 19,
    firstName: 'John ',
    lastName: 'Hendrix',
    role: 'APP-client-user',
    email: 'john_h@companytwo.com',
    org_id: 254,
  },
  {
    id: 20,
    firstName: 'John ',
    lastName: 'Armstrong',
    role: 'APP-client-user',
    email: 'john_h@companytwo.com',
    org_id: 254,
  },
]
